import React, { useMemo, useState } from "react";
import { Section as SectionType } from "..";
import styled from "styled-components";
import { Item } from "./Item";
import { useMenuContext } from "Components/MenuProvider";
import { FlexRow } from "Components/Flex";
import { ReactComponent as ChevronRoundedIcon } from "assets/svg/chevron-rounded.svg";
import { useLocation } from "react-router-dom";

interface Props {
  section: SectionType;
}

export const Section: React.FC<Props> = ({ section }) => {
  const { menuMode } = useMenuContext();

  const location = useLocation();

  const [sectionCollapsed, setSectionCollapsed] = useState(false);

  const selectedItem = useMemo(
    () => section.items.find((item) => item.path === location.pathname),
    [location.pathname, section.items],
  );

  return (
    <Container data-menu-mode={menuMode}>
      {menuMode === "expanded" && section.title && (
        <CollapseMenu
          $collapsed={
            section.collapseable === false || menuMode !== "expanded"
              ? false
              : sectionCollapsed
          }
          yEnd
          xSpaceBetween
          onClick={() => setSectionCollapsed((collapsed) => !collapsed)}
        >
          {section.title && <Title>{section.title}</Title>}
          {section.collapseable !== false && (
            <FlexRow>
              {selectedItem && sectionCollapsed && (
                <Chip xCenter yCenter>
                  {selectedItem.icon}
                </Chip>
              )}
              <StyledChevron $collapsed={sectionCollapsed} />
            </FlexRow>
          )}
        </CollapseMenu>
      )}
      <Items $collapsed={menuMode === "expanded" && sectionCollapsed}>
        {section.items.map((item) => (
          <Item key={item.title} item={item} />
        ))}
      </Items>
    </Container>
  );
};

export const Chip = styled(FlexRow)`
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  background-color: black;
  color: white;
  font-size: 10px;
  padding: 5px;
  margin: -9px 15px 9px 0;
  border-radius: 50%;
  align-items: center;
  width: 25px;
  height: 25px;
  right: 30px;
  position: absolute;
`;

const CollapseMenu = styled(FlexRow)<{ $collapsed: boolean }>`
  width: 100%;
  padding: 17px 20px;
  cursor: pointer;
`;

const Container = styled.div`
  position: relative;
  padding: 10px 0;
`;

const Items = styled.div<{ $collapsed: boolean }>`
  display: flex;
  flex-direction: column;

  display: ${({ $collapsed }) => ($collapsed ? "none" : "block")};
`;

const StyledChevron = styled(ChevronRoundedIcon)<{ $collapsed: boolean }>`
  transform: ${({ $collapsed }) => ($collapsed ? "scaleY(1)" : "scaleY(-1)")};
  transition: transform 0.1s;
`;

const Title = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: #4c4c4c;
`;
